import { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";
import { useLazyDeleteSubAdminQuery, useLazyGetSubAdminQuery } from "../../service/subAdmin";
import { showError, showToast } from "../../constants/toasts";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import Loader from "../../constants/Loader";
import { useLazyChangeUserStatusQuery } from "../../service/user";

const ManageSubadmin = () => {
  const [getSubAdmin] = useLazyGetSubAdminQuery()
  const [deleteApi] = useLazyDeleteSubAdminQuery()
  const [changeStatus] = useLazyChangeUserStatusQuery();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [count, setCount] = useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([])
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const getSubAdminsApi = async () => {
    setLoading(true);
    try {
      const response = await getSubAdmin({
        search: debouncedSearchTerm.trim(),
        page,
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setData(response?.data?.subAdmins || []);
        setCount(response?.data?.total);
      } else {
        setData([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleStatusChange = async (id: string) => {
    try {
      const response = await changeStatus({ userId: id }).unwrap();
      if (response?.status === 200) {
        showToast(response?.message || "");
        getSubAdminsApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteApi({
        id,
      }).unwrap();
      if (response.status === 200) {
        getSubAdminsApi();
        showToast(response?.message);
      } else {
        showError(response?.message);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };


  useEffect(() => {
    getSubAdminsApi();
  }, [page, debouncedSearchTerm]);


  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <h1>Manage Sub-Admin</h1>
        <SubadminListTopbar />
      </div>

      <div className="cards table_cards v2">

        <SubadminList data={data} setSelectedId={setSelectedId} setOpenDelete={setOpenDelete} handleStatusChange={handleStatusChange} />
      </div>
      <ConfirmationModal
        text={"Are you sure to delete this Sub Admin?"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => {
          handleDelete(selectedId);
        }}
      />
    </MainContainer>
  );
};

export default ManageSubadmin;
